
import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization, getApiWithoutAuthorization, postApiWithAuthorization } from "../ApiMethod/ApiMethod";

const baseURL = `${NewUpdatedBaseUrl}/Puja`


export const GetPujaCatLookupList = async (params) => {
    const url = `${NewUpdatedBaseUrl}/PujaCategory/GetPujaCatLookupList`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};

export const GetPujaLookupList = async (params) => {
    const url = `${baseURL}/GetPujaLookupList`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};

export const PujaDetailsBySlug = async (params) => {
    const url = `${baseURL}/PujaDetailsBySlug`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};
export const PujaBooking = async (params) => {
    const url = `${baseURL}/PujaBooking`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};

export const GetPujaOrderListByUserIDList = async (params, UserKeyID, AppLangID) => {
    const url = `${baseURL}/GetPujaOrderListByUserIDList?UserKeyID=${UserKeyID}&AppLangID=${AppLangID}`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};

export const GetPujaOrderDetails = async (PujaBookingKeyID, AppLangID) => {
    const url = `${baseURL}/GetPujaOrderDetails?PujaBookingKeyID=${PujaBookingKeyID}&AppLangID=${AppLangID}`;
    const res = await getApiWithAuthorization(url);
    return res;
};
export const GetPujaListBySearch = async (PujaName, AppLangID) => {
    const languageID = Number(AppLangID);
    const url =
        languageID === 1
            ? `${baseURL}/GetSearchList?SearchText=${PujaName}`
            : `${baseURL}/GetSearchList?SearchText=${PujaName}&AppLangID=${languageID}`;

    const res = await getApiWithAuthorization(url);
    return res;
};

export const PayRemainingPujaBookingAmount = async (params) => {
    const url = `${baseURL}/PayRemainingPujaBookingAmount`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};

export const GetPopolarPujaList = async (PujaServiceID, PujaSubServiceID, AppLangID) => {
    const url = `${baseURL}/GetPopolarPujaList?PujaServiceID=${PujaServiceID}&PujaSubServiceID=${PujaSubServiceID}&AppLangID=${AppLangID}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};
export const GetPujaOrderTrackingDetails = async (PujaBookingKeyID, UserKeyID, AppLangID) => {
    const url = `${baseURL}/GetPujaOrderTrackingDetails?PujaBookingKeyID=${PujaBookingKeyID}&UserKeyID=${UserKeyID}&AppLangID=${AppLangID}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};
